import { render, staticRenderFns } from "./swpAssessment.vue?vue&type=template&id=9c7046c8"
import script from "./swpAssessment.vue?vue&type=script&lang=js"
export * from "./swpAssessment.vue?vue&type=script&lang=js"
import style0 from "./swpAssessment.vue?vue&type=style&index=0&id=9c7046c8&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c7046c8')) {
      api.createRecord('9c7046c8', component.options)
    } else {
      api.reload('9c7046c8', component.options)
    }
    module.hot.accept("./swpAssessment.vue?vue&type=template&id=9c7046c8", function () {
      api.rerender('9c7046c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/swp/swpAssessment.vue"
export default component.exports